<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
  <span class="unit-name">{{ data.turnover.propertyName }} - {{ data.turnover.unitName }}: </span>
  <span class="column-name">{{ data.column.name }}</span>
</h2>
<form [formGroup]="form" (ngSubmit)="ok()">
  <mat-dialog-content>
    <div class="form display-flex flex-column grid-gap-16">
      <div class="display-flex grid-gap-24 align-items-center">
        <app-date-dropdown
          formControlName="dueDate"
          [labelCss]="'nowrap pre-label'"
          [valueCss]="'text-color dark pre-option'"
          [buttonCss]="'w-162'"
          [containerCss]="'display-flex flex-column grid-gap-4'"
          [label]="'Due Date'"
          [min]="today"
          [labelRequired]="true"
        ></app-date-dropdown>

        <app-radio-button-dropdown
          [label]="'Inspection'"
          [containerCss]="'display-flex flex-column grid-gap-4'"
          [labelCss]="'nowrap pre-label'"
          [allowClear]="true"
          formControlName="inspectionTemplateId"
          [items]="inspectionTemplatesOptions"
          [listLoading]="isInspectionTemplatesLoading$ | async"
          [attrPlaceholder]="'none'"
          [attrAppendTo]="appendTo"
        ></app-radio-button-dropdown>
      </div>
      <div class="display-flex flex-column grid-gap-8">
        <div class="display-flex grid-gap-24 align-items-center">
          <label>Assignee</label>
          <app-slide-toggle
            [attrLeftLabel]="'User'"
            [labelCss]="'body-small'"
            [attrRightLabel]="'Vendor'"
            formControlName="isVendor"
            [activeBold]="false"
          ></app-slide-toggle>
        </div>
        <div *ngIf="form.value.isVendor">
          <app-radio-button-dropdown
            [containerCss]="'display-flex flex-column grid-gap-4'"
            labelCss="'nowrap"
            [allowClear]="true"
            formControlName="vendor"
            [items]="vendorList"
            [attrPlaceholder]="'select vendor'"
            [attrAppendTo]="appendTo"
            [allowAddNew]="true"
            [addNewLabel]="'+ Add new vendor'"
            (addNewClicked)="addNewVendor()"
          ></app-radio-button-dropdown>
        </div>
        <div class="display-flex align-items-end grid-gap-10">
          <app-user-select-dropdown
            *ngIf="!form.value.isVendor"
            [containerCss]="'display-flex flex-column grid-gap-4'"
            labelCss="'nowrap"
            [allowClear]="true"
            formControlName="assignee"
            [users]="userListModel"
            [attrPlaceholder]="'select assignee'"
            [showValidationError]="form.controls.assignee?.touched"
            [listLoading]="propertyUserListLoading$ | async"
            [showChevron]="true"
            [attrAppendTo]="appendTo"
          ></app-user-select-dropdown>
          <ng-container *ngIf="form.value.isVendor && form.value.vendor > 0">
            <app-radio-button-dropdown
              [containerCss]="'display-flex flex-column grid-gap-4'"
              labelCss="'nowrap"
              [allowClear]="true"
              formControlName="assignee"
              [items]="vendorAssigneeList"
              [attrPlaceholder]="'select vendor employee'"
              [attrAppendTo]="appendTo"
              [allowAddNew]="form.controls.vendor.value !== null"
              [addNewLabel]="'+ Add new employee'"
              (addNewClicked)="addNewVendorAssignee()"
            ></app-radio-button-dropdown>
          </ng-container>
          <mat-checkbox color="primary" formControlName="notifyAssignee">notify</mat-checkbox>
        </div>
      </div>
      <div class="slider-container">
        <mat-slide-toggle
          matTooltip="Remember assignee for: {{ data.column.name }}"
          formControlName="remember"
          color="primary"
        >
          remember my choices
        </mat-slide-toggle>
        <mat-slide-toggle
          formControlName="remember"
          color="primary"
          [(ngModel)]="showNote"
          (ngModelChange)="focusOnComment()"
        >
          add one-time note
        </mat-slide-toggle>
      </div>
      <app-content-editable-area
        *ngIf="showNote"
        #commentArea
        [attrPlaceholder]="'A one-time custom note...'"
        [autoresize]="true"
        [maxHeight]="110"
        [inputCss]="'comment-section'"
        formControlName="note"
      ></app-content-editable-area>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <app-button
      [buttonColor]="'warn'"
      [buttonType]="ButtonType.STROKED"
      (clickEvent)="cancel()"
      type="button"
      [buttonLabel]="'Cancel'"
    ></app-button>
    <app-button
      [buttonType]="ButtonType.RAISED"
      type="submit"
      [buttonLabel]="isReschedule ? 'Reschedule' : 'Schedule'"
    ></app-button>
  </mat-dialog-actions>
</form>
